Promise = require 'bluebird'
assert = require 'app/scripts/lib/assert'
HttpError = require 'app/scripts/network/http-error'
$ = require 'jquery'
xtend = require 'xtend'

module.exports = (args) ->
  assert 'success' !of args && 'error' !of args, "This is promise country!"

  new Promise (resolve, reject) ->
    $.ajax xtend args,
      success: (data) ->
        resolve data
      error: (xhr) ->
        reject HttpError.fromResponse(xhr.status, xhr.responseText)
